/* eslint-disable import/prefer-default-export,no-new,no-console,prefer-const,no-unused-vars */
import Cookies from '@/services/cookies'
import * as types from './mutation_types'
import apiClient from '@/api/client'

export default {
  checkDefaultCityCookie: ({ dispatch, getters, rootState }) =>
    new Promise((resolve) => {
      let city = Object.values(getters.getAll).find(
        city => city.landingUrl && window.location.href.includes(city.landingUrl),
      )
      if (city) {
        dispatch('confirmActive', city)
        resolve()
        return
      }
      // Смотрим название города в куках или роуте
      let defaultCityAlias = getters.getCityAliasFromCookie
      // TODO: выяснить как город будет передаваться в роуте, какой город по дефолту ставить?
      const cityString =
        defaultCityAlias || rootState?.route?.path?.replace(/[^A-Za-z]/g, '') || 'spb'

      if (cityString !== 'other') {
        city = Object.values(getters.getAll).find(
          city => city.alias === cityString,
        )

        // Если нет предустановленного города, то выбираем первый попавшийся
        if (!city) city = Object.values(getters.all)[0]
        dispatch('confirmActive', city)
      } else {
        city = Object.values(getters.getAll)[0]
        dispatch('confirmActive', city)
        dispatch('setOtherCityMode', { flag: true })
      }
      resolve()
    }),
  confirmActive: ({ commit, dispatch }, city) =>
    new Promise((resolve) => {
      /*
       * Если не указан noredirect или он в значении true указываем в url город,
       * иначе мы переходим в аккаунт пользователя
       * */
      commit(types.SET_ACTIVE, city)
      Cookies.set('default_city', city.alias, { expires: 30 })
      document.cookie = `default_city=${city.alias}; path=/`
      resolve()
    }),
  setOtherCityMode: ({ commit, dispatch, getters, rootGetters }, data) => new Promise((resolve) => {
    commit(types.SET_OTHER_CITY_MODE, data.flag)
    resolve()
  }),
  setCities: ({ commit, dispatch, getters, rootGetters }, cities) => new Promise((resolve) => {
    commit(types.SET_CITIES, cities)
    resolve()
  }),

  getCities: async ({ dispatch }) => {
    try {
      const response = await apiClient.getStandardJson(window.cacheRefresher)
      const cities = response.data.cities
      dispatch('setCities', cities)
    } catch (error) {
      console.error(error)
    }
  },
}
